import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import config from "../config";
import {AccountRecordFormProps} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & Omit<AccountRecordFormProps, 'handleCancel'>) => {

    const title = record.id
        ? `Edit ${config.titles.singular}`
        : `New ${config.titles.singular}`

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                // FNP-555: await the mutation BEFORE closing. Closing
                // unconditionally discarded the operator's input on a
                // server-side rejection and fired notifyError into a drawer
                // that was already gone.
                handleSubmit={async (values) => {
                    await handleSubmit(values);
                    onClose();
                }}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
